import UPProvidersTable from './UPProvidersTable';

export default UPProvidersTable;
